//#region src/locales/es/tamagotchi/electron/tray.yaml
var data = { "menu": { "labels": { "label": {
	"show": "Mostrar",
	"adjust_sizes": "Ajustar tamaños",
	"recommended_size": "Recomendado (450x600)",
	"full_height": "Altura Completa",
	"half_height": "Altura media",
	"full_screen": "Pantalla Completa",
	"align_to": "Alinear a",
	"center": "Centro",
	"top_left": "Superior Izquierda",
	"top_right": "Superior Derecha",
	"bottom_left": "Inferior Izquierda",
	"bottom_right": "Inferior Derecha",
	"settings": "Configuraciones...",
	"about": "Acerca de...",
	"open_inlay": "Abrir Inlay...",
	"open_widgets": "Abrir Accesorios...",
	"open_caption": "Abir Subtítulo...",
	"close_caption": "Cerrar Subtítulo...",
	"caption_overlay": "Superposición de Subtítulos",
	"follow_window": "Seguir ventana",
	"reset_position": "Reiniciar Posición",
	"devtools": "Herramientas de Desarrollador",
	"troubleshoot_beatsync": "Solucionar problemas BeatSync...",
	"quit": "Salir"
} } } };
//#endregion
export { data as default };
